import React, { useEffect, useMemo, useRef } from "react";
import { createPlateoMascot, iconSVG } from "./plateoMascotEngine";

// Animated Platypus.
// running=false: his face (blinks now and then).
// running=true:  zooms out, turns, drops to four legs and runs until running goes false,
//                then stands back up, turns to face you and winks.
export default function PlateoMascot({ running = false, size = 120, speed = 1, className, style }) {
  const ref = useRef(null);
  const api = useRef(null);

  useEffect(() => {
    api.current = createPlateoMascot(ref.current, { running, speed });
    return () => api.current?.destroy();
    // Only mount once; running changes go through setRunning below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    api.current?.setRunning(running);
  }, [running]);

  return (
    <div
      ref={ref}
      className={className}
      style={{ width: size, height: size, ...style }}
      role="img"
      aria-label={running ? "Platypus is hunting for jobs" : "Platypus"}
    />
  );
}

// Static face for the sidebar, headers and small spots.
export function PlateoMascotIcon({ size = 24, className, style }) {
  const html = useMemo(() => iconSVG(size), [size]);
  return (
    <span
      className={className}
      style={{ display: "inline-flex", width: size, height: size, flexShrink: 0, lineHeight: 0, ...style }}
      dangerouslySetInnerHTML={{ __html: html }}
      role="img"
      aria-label="Platypus"
    />
  );
}
